import { put, takeLatest, call } from 'redux-saga/effects';

import {
  getCommunitiesSuccess,
  getCommunityByIdSuccess,
  deleteCommunitySuccess,
  updateCommunitySuccess,
} from '../actionCreators/communitiesActions';
import {
  GET_COMMUNITY_BY_ID_REQUEST,
  GET_COMMUNITIES_REQUEST,
  DELETE_COMMUNITY_REQUEST,
  UPDATE_COMMUNITY_REQUEST,
} from '../constants/actionTypes';
import { addAlertToAlertsList } from '../actionCreators/globalAlerts';
import { CommunitiesApi } from '../api';
import errorHandler from '../utils/requestErrorHandler';

function* getCommunities(action) {
  try {
    const data = yield call(CommunitiesApi.getCommunities, action.payload);

    yield put(getCommunitiesSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getCommunityById(action) {
  try {
    const data = yield call(CommunitiesApi.getCommunityById, action.payload);

    yield put(getCommunityByIdSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* deleteCommunity(action) {
  try {
    const data = yield call(CommunitiesApi.deleteCommunity, action.payload.communityId);
    if (data.success) {
      yield put(deleteCommunitySuccess(action.payload.communityId));
    } else {
      yield put(
        addAlertToAlertsList({
          title: 'Community',
          message:
            data && data.message
              ? data.message
              : 'Unable to delete community. Please try again later.',
          messageStyle: { color: '#505A62', textAlign: 'left', width: '100%' },
          confirmBtnText: 'OKAY',
        }),
      );
    }
  } catch (error) {
    yield errorHandler(error);
  }
}

function* updateCommunityRequest(action) {
  try {
    const data = yield call(CommunitiesApi.updateCommunity, action.payload);
    if (data.success) {
      yield put(updateCommunitySuccess(data.community));
      yield put(
        addAlertToAlertsList({
          title: 'Community',
          message: 'Your Community was updated successfully.',
          messageStyle: { color: '#505A62', textAlign: 'left', width: '100%' },
          confirmBtnText: 'OKAY',
          confirmBtnAction: action.payload.cb,
        }),
      );
    } else {
      yield put(
        addAlertToAlertsList({
          title: 'Community',
          message:
            data && data.message
              ? data.message
              : 'Unable to updated community. Please try again later.',
          messageStyle: { color: '#505A62', textAlign: 'left', width: '100%' },
          confirmBtnText: 'OKAY',
        }),
      );
    }
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchChallenge() {
  yield takeLatest(GET_COMMUNITIES_REQUEST, getCommunities);
  yield takeLatest(GET_COMMUNITY_BY_ID_REQUEST, getCommunityById);
  yield takeLatest(DELETE_COMMUNITY_REQUEST, deleteCommunity);
  yield takeLatest(UPDATE_COMMUNITY_REQUEST, updateCommunityRequest);
}
